const moduleElements = document.querySelectorAll('[data-module]')
for (var i = 0; i < moduleElements.length; i++) {
  const el = moduleElements[i]
  const name = el.getAttribute('data-module')
  require.ensure([], function() {
    const Module = require(`../modules/${name}`)
    new Module(el)
  })
}

const componentElements = document.querySelectorAll('[data-component]')
for (var i = 0; i < componentElements.length; i++) {
  const el = componentElements[i]
  const name = el.getAttribute('data-component')
  require.ensure([], function() {
    const Component = require(`../components/${name}`)
    new Component(el)
  })
}

const entryElements = document.querySelectorAll('[data-entry]')
for (var i = 0; i < entryElements.length; i++) {
  const el = entryElements[i]
  const name = el.getAttribute('data-entry')
  require.ensure([], function() {
    const Entry = require(`../entry/${name}`)
    new Entry(el)
  })
}


// Custom loader for Kentico forms
// const kenticoForms = document.querySelectorAll('.FormPanel')
// for (var i = 0; i < kenticoForms.length; i++) {
//   const el = kenticoForms[i]
//   require.ensure([], function() {
//     const Entry = require(`../components/form`)
//     new Entry(el)
//   })
// }




/** WEBPACK FOOTER **
 ** ./system/loader.js
 **/